import React from 'react';
import { X } from 'lucide-react';
import { Badge } from './ui/badge';

export const ProjectModal = ({ project, isOpen, onClose }) => {
  if (!isOpen || !project) return null;

  return (
    <div 
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-75 p-4"
      onClick={onClose}
    >
      <div 
        className="relative bg-white rounded-lg max-w-4xl w-full max-h-[90vh] overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 z-10 p-2 bg-white rounded-full shadow-lg hover:bg-gray-100 transition-colors duration-200"
        >
          <X size={24} className="text-gray-900" />
        </button>

        {/* Content */}
        <div className="overflow-y-auto max-h-[90vh]">
          {/* Image or Video */}
          <div className="relative">
            {project.type === 'video' ? (
              <div className="bg-black flex items-center justify-center" style={{ minHeight: '400px' }}>
                <video
                  src={project.image}
                  className="w-auto h-auto"
                  style={{ maxHeight: '70vh', maxWidth: '100%' }}
                  controls
                  autoPlay
                  controlsList="nodownload"
                  onContextMenu={(e) => e.preventDefault()}
                >
                  Votre navigateur ne supporte pas la lecture de vidéos.
                </video>
              </div>
            ) : (
              <img
                src={project.image}
                alt={project.title}
                className="w-full h-auto object-cover"
              />
            )}
            <div className="absolute top-4 left-4">
              <Badge
                className={`${
                  project.status === 'Achevé'
                    ? 'bg-green-500 hover:bg-green-600'
                    : project.status === 'En finition'
                    ? 'bg-blue-500 hover:bg-blue-600'
                    : 'bg-orange-500 hover:bg-orange-600'
                } text-white text-base px-4 py-2`}
              >
                {project.status}
              </Badge>
            </div>
          </div>

          {/* Details */}
          <div className="p-8">
            <h2 className="text-3xl font-bold text-gray-900 mb-2">
              {project.title}
            </h2>
            <p className="text-lg text-blue-600 font-medium mb-4">
              {project.category}
            </p>
            <p className="text-gray-700 text-lg leading-relaxed mb-6">
              {project.description}
            </p>
            
            {/* Additional Info */}
            <div className="border-t border-gray-200 pt-6">
              <h3 className="text-xl font-semibold text-gray-900 mb-4">
                Caractéristiques du projet
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <p className="text-sm text-gray-500 mb-1">Type de projet</p>
                  <p className="text-base font-medium text-gray-900">{project.category}</p>
                </div>
                <div>
                  <p className="text-sm text-gray-500 mb-1">Statut</p>
                  <p className="text-base font-medium text-gray-900">{project.status}</p>
                </div>
                <div>
                  <p className="text-sm text-gray-500 mb-1">Localisation</p>
                  <p className="text-base font-medium text-gray-900">{project.location}, Sénégal</p>
                </div>
                <div>
                  <p className="text-sm text-gray-500 mb-1">Entreprise</p>
                  <p className="text-base font-medium text-gray-900">GENICONCEPT</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};